import { render } from "./AIChatInput.vue?vue&type=template&id=70e2af41&scoped=true"
import script from "./AIChatInput.vue?vue&type=script&lang=js"
export * from "./AIChatInput.vue?vue&type=script&lang=js"

import "./AIChatInput.vue?vue&type=style&index=0&id=70e2af41&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e2af41"]])

export default __exports__